import {
  Icon3DLine,
  IconBinocularsGray,
  IconBuildings,
  IconCctvLine,
  IconChainLink,
  IconClockGray,
  IconCloud,
  IconGlobal,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconShare,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';

import image1 from '@src/assets/images/digitaltwin/image/image1.avif';
import image2 from '@src/assets/images/digitaltwin/image/image2.avif';

import gis from '@src/assets/images/digitaltwin/video/gis.mp4';
import weather from '@src/assets/images/digitaltwin/video/weather.mp4';
import buildings from '@src/assets/images/digitaltwin/video/buildings.mp4';
import tracking from '@src/assets/images/digitaltwin/video/tracking.mp4';
import traffic from '@src/assets/images/digitaltwin/video/traffic.mp4';
import airplane from '@src/assets/images/digitaltwin/video/airplane.mp4';
import cctv from '@src/assets/images/digitaltwin/video/cctv.mp4';

export default {
  type: 'City Solution',

  banner: {
    title: 'Manage city infrastructure efficiently with a digital twin.',
    desc: 'Monitor the status and operation of city infrastructure in real time with digital-twin technology and manage it efficiently to enhance stability and performance.',
  },

  video: {
    title: 'See the status of all city infrastructure at a glance with digital-twin technology.',
    desc: 'Leverage digital-twin technology to integrate and visualize the status and operational data of key city infrastructure in real time, enabling systematic and efficient management.',
    // play: mainVideo,
    image: image1,
  },

  func: [
    {
      theme: 'Check and manage city infrastructure in real time with a digital twin.',
      title: 'Real-time 3D visualization',
      desc: 'Accurately model city buildings and internal facilities in 3D so you can intuitively view live information, grasp operational status quickly, and run everything more efficiently.',
      sub1: 'High accuracy',
      icon1: IconRulerGray,
      sub2: 'Live status view',
      icon2: IconClockGray,
      video: gis,
    },
    {
      title: 'Live weather and air-quality integration',
      desc: 'Sync real-world weather data—rain, snow and more—directly into the system in real time to provide an immersive, precise operating environment.',
      sub1: 'Fast data integration',
      icon1: IconTvocGray,
      sub2: 'Real-time location tracking',
      icon2: IconBinocularsGray,
      video: weather,
    },
    {
      title: 'Real-time building information',
      desc: 'Monitor facility status and maintenance schedules in real time, and predict equipment failures and energy use with sensor data to support efficient, eco-friendly operations.',
      sub1: 'Real-time location tracking',
      icon1: IconBinocularsGray,
      sub2: 'High accuracy',
      icon2: IconRulerGray,
      video: buildings,
    },
    {
      title: 'Live indoor-map rendering',
      desc: 'Reflect the positions of indoor assets and people in real time, accurately capturing foot-traffic flows and security conditions to support rapid operations and response.',
      sub1: 'Flexible area settings',
      icon1: IconZoneGray,
      sub2: 'Multiple-zone support',
      icon2: IconTagGray,
      video: tracking,
    },
    {
      theme: 'Integrate movement and safety data city-wide for efficient operations.',
      title: 'Live people & vehicle movement management',
      desc: 'Analyze vehicle and pedestrian movement in real time to prevent congestion and respond instantly to safety incidents—empowering swift, precise city operations.',
      sub1: 'Flexible area settings',
      icon1: IconTagGray,
      sub2: 'Multiple-zone support',
      icon2: IconZoneGray,
      image: image2,
    },
    {
      title: 'Real-time public-transport integration',
      desc: 'Provide live bus and subway operations to suggest optimal routes and minimize congestion, dramatically improving traffic efficiency.',
      sub1: 'High accuracy',
      icon1: IconZoneGray,
      sub2: 'Multiple-zone support',
      icon2: IconTagGray,
      video: traffic,
    },
    {
      title: 'Live flight-status connection',
      desc: 'Link real-time flight information to instantly notify delays or changes, smoothing travel flows and boosting operational efficiency.',
      sub1: 'Rapid setup',
      icon1: IconTagGray,
      sub2: 'Multiple-zone support',
      icon2: IconTagGray,
      video: airplane,
    },
    {
      title: 'Real-time CCTV monitoring & management',
      desc: 'Connect city CCTV feeds in real time to detect anomalies immediately, preventing crime and managing traffic swiftly for safer cities.',
      sub1: 'Live visualization',
      icon1: IconShareGray,
      sub2: 'Multiple-zone support',
      icon2: IconTagGray,
      video: cctv,
    },
  ],

  subfunc: {
    title: 'Key Features Overview',
    desc: '',

    data: [
      {
        icon: Icon3DLine,
        title: 'Real-time 3D visualization',
        desc: '3D rendering and monitoring of city facilities in real time',
      },
      {
        icon: IconCloud,
        title: 'Live weather integration',
        desc: 'Real-world weather data synced to the system in real time',
      },
      {
        icon: IconBuildings,
        title: 'Building information',
        desc: 'Real-time monitoring of building status and energy use',
      },
      {
        icon: IconRoom,
        title: 'Live indoor maps',
        desc: 'Real-time mapping of indoor assets and people',
      },
      {
        icon: IconRoute,
        title: 'Movement analytics',
        desc: 'Real-time analysis of vehicle and pedestrian movement',
      },
      {
        icon: IconChainLink,
        title: 'Public-transport integration',
        desc: 'Live positioning for buses, subways and more',
      },
      {
        icon: IconShare,
        title: 'Live flight integration',
        desc: 'Real-time flight-status data linked to the system',
      },
      {
        icon: IconCctvLine,
        title: 'Live CCTV monitoring',
        desc: 'Real-time CCTV analysis to keep the city safe',
      },
      {
        icon: IconGlobal,
        title: 'GIS platform link',
        desc: 'Efficient spatial-data management via GIS integration',
      },
      {
        icon: IconChainLink,
        title: 'External-system API link',
        desc: 'Flexible integration of diverse data sources',
      },
    ],
  },

  system: {
    title: 'System Architecture',
    img: rtlsSystem,
  },

  productTitle: 'Product Packages',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
